import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'
import Filter from 'containers/Reports/AssetToleranceReport/Filter'
import { formatValue } from 'helpers/listViews'

export default createListViewComponent({
  entityName: entityNames.assetToleranceReport,
  filterTemplateType: 'AssetToleranceReport',
  initialFilterDto: (self) => ({ dateRange: { dateRangeType: 'YearToDate' } }),
  allowCreate: (self) => false,
  allowSelection: (self) => false,
  tableCellComponents: {
    value: (self, item) => {
      if (!item?.value) {
        return ''
      }

      const text = formatValue({
        value: item.value,
        displayFormat: self.state.fieldSettings.find((one) => one.dtoFieldName === 'value').displayFormat,
      })

      return item.value > item.max || item.value < item.min ? (
        <div className="table-cell-error">
          <span>{text}</span>
        </div>
      ) : (
        text
      )
    },
  },
})(Filter)
